<template>
  <div>
    <svg
      class="wCYvWN"
      style="display: none; width: 0; height: 0"
      width="0"
      height="0"
      focusable="false"
      aria-hidden="true"
    >
      <symbol id="icon-doorlock" viewBox="0 0 1024 1024">
        <path
          d="M159.96 119.44l523.27 0 0 785.12-523.27 0 0-785.12Z"
          fill="#CDF1F3"
        ></path>
        <path
          d="M623 920.5H220.2a76.28 76.28 0 0 1-76.2-76.19V179.69a76.28 76.28 0 0 1 76.2-76.19H623a76.27 76.27 0 0 1 76.18 76.19v664.62A76.27 76.27 0 0 1 623 920.5zM220.2 135.38a44.37 44.37 0 0 0-44.31 44.31v664.62a44.37 44.37 0 0 0 44.31 44.31H623a44.36 44.36 0 0 0 44.3-44.31V179.69a44.36 44.36 0 0 0-44.3-44.31z"
          fill="#05BAC5"
        ></path>
        <path
          d="M434.24 519.36m-141.03 0a141.03 141.03 0 1 0 282.06 0 141.03 141.03 0 1 0-282.06 0Z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M434.24 676.33c-86.56 0-157-70.41-157-157s70.41-157 157-157 157 70.41 157 157-70.44 157-157 157z m0-282.05a125.09 125.09 0 1 0 125.09 125.09 125.22 125.22 0 0 0-125.09-125.09z"
          fill="#05BAC5"
        ></path>
        <path
          d="M379.14 450.59l484.91 0 0 145.26-484.91 0 0-145.26Z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M791.42 611.79H451.77a88.57 88.57 0 0 1 0-177.14h339.65a88.57 88.57 0 1 1 0 177.14zM451.77 466.53a56.69 56.69 0 0 0 0 113.38h339.65a56.69 56.69 0 0 0 0-113.38z"
          fill="#05BAC5"
        ></path>
      </symbol>
      <symbol id="icon-ammeter" viewBox="0 0 1024 1024">
        <path
          d="M191.35 119.52h636.4a56.93 56.93 0 0 1 56.93 56.93v671.11a56.93 56.93 0 0 1-56.93 56.93h-631.5a56.93 56.93 0 0 1-56.93-56.93v-676a52 52 0 0 1 52.03-52.04z"
          fill="#CDF1F3"
        ></path>
        <path
          d="M827.76 920.5H196.24a73 73 0 0 1-72.92-72.94v-676a68.11 68.11 0 0 1 68-68h636.44a73 73 0 0 1 72.92 72.94v671.06a73 73 0 0 1-72.92 72.94z m-636.41-785a36.07 36.07 0 0 0-36 36v676a41 41 0 0 0 40.91 40.93h631.5a41 41 0 0 0 40.91-40.93V176.44a41 41 0 0 0-40.91-40.93z"
          fill="#05BAC5"
        ></path>
        <path
          d="M243.77 233.47l543.32 0 0 344.43-543.32 0 0-344.43Z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M725 593.9H306a78.23 78.23 0 0 1-78.15-78.15V295.61A78.23 78.23 0 0 1 306 217.46h419a78.23 78.23 0 0 1 78.15 78.15v220.14A78.23 78.23 0 0 1 725 593.9zM306 249.46a46.19 46.19 0 0 0-46.14 46.14v220.15A46.19 46.19 0 0 0 306 561.89h419a46.19 46.19 0 0 0 46.14-46.14V295.61A46.19 46.19 0 0 0 725 249.47z"
          fill="#05BAC5"
        ></path>
        <path
          d="M301.6 732.91m-57.83 0a57.83 57.83 0 1 0 115.66 0 57.83 57.83 0 1 0-115.66 0Z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M301.59 806.75a73.84 73.84 0 1 1 73.84-73.84 73.91 73.91 0 0 1-73.84 73.84z m0-115.67a41.83 41.83 0 1 0 41.83 41.83 41.86 41.86 0 0 0-41.83-41.83z"
          fill="#05BAC5"
        ></path>
        <path
          d="M519.05 732.91m-57.83 0a57.83 57.83 0 1 0 115.66 0 57.83 57.83 0 1 0-115.66 0Z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M519 806.75a73.84 73.84 0 1 1 73.84-73.84A73.91 73.91 0 0 1 519 806.75z m0-115.67a41.83 41.83 0 1 0 41.83 41.83A41.87 41.87 0 0 0 519 691.08z"
          fill="#05BAC5"
        ></path>
        <path
          d="M736.5 732.91m-57.83 0a57.83 57.83 0 1 0 115.66 0 57.83 57.83 0 1 0-115.66 0Z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M736.5 806.75a73.84 73.84 0 1 1 73.84-73.84 73.91 73.91 0 0 1-73.84 73.84z m0-115.67a41.83 41.83 0 1 0 41.83 41.83 41.87 41.87 0 0 0-41.83-41.83zM596.59 396.71L475.87 510.09c-6.37 6-16.82-0.42-13.7-8.31l26.44-66.45c2-5.12-2-10.59-7.82-10.59h-54.06c-7.34 0-11.08-8.24-6- 13.22l115-113.38c6.23-6.16 17 0.07 13.91 8l-25.47 66.65c-1.94 5.12 2.08 10.45 7.82 10.45h58.71c7.41 0 11.14 8.45 5.88 13.43z"
          fill="#05BAC5"
        ></path>
        <path
          d="M191.35 119.52h636.4a56.93 56.93 0 0 1 56.93 56.93v671.11a56.93 56.93 0 0 1-56.93 56.93h-631.5a56.93 56.93 0 0 1-56.93-56.93v-676a52 52 0 0 1 52.03-52.04z"
          fill="#CDF1F3"
        ></path>
        <path
          d="M827.76 920.5H196.24a73 73 0 0 1-72.92-72.94v-676a68.11 68.11 0 0 1 68-68h636.44a73 73 0 0 1 72.92 72.94v671.06a73 73 0 0 1-72.92 72.94z m-636.41-785a36.07 36.07 0 0 0-36 36v676a41 41 0 0 0 40.91 40.93h631.5a41 41 0 0 0 40.91-40.93V176.44a41 41 0 0 0-40.91-40.93z"
          fill="#05BAC5"
        ></path>
        <path
          d="M243.77 233.47l543.32 0 0 344.43-543.32 0 0-344.43Z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M725 593.9H306a78.23 78.23 0 0 1-78.15-78.15V295.61A78.23 78.23 0 0 1 306 217.46h419a78.23 78.23 0 0 1 78.15 78.15v220.14A78.23 78.23 0 0 1 725 593.9zM306 249.46a46.19 46.19 0 0 0-46.14 46.14v220.15A46.19 46.19 0 0 0 306 561.89h419a46.19 46.19 0 0 0 46.14-46.14V295.61A46.19 46.19 0 0 0 725 249.47z"
          fill="#05BAC5"
        ></path>
        <path
          d="M301.6 732.91m-57.83 0a57.83 57.83 0 1 0 115.66 0 57.83 57.83 0 1 0-115.66 0Z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M301.59 806.75a73.84 73.84 0 1 1 73.84-73.84 73.91 73.91 0 0 1-73.84 73.84z m0-115.67a41.83 41.83 0 1 0 41.83 41.83 41.86 41.86 0 0 0-41.83-41.83z"
          fill="#05BAC5"
        ></path>
        <path
          d="M519.05 732.91m-57.83 0a57.83 57.83 0 1 0 115.66 0 57.83 57.83 0 1 0-115.66 0Z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M519 806.75a73.84 73.84 0 1 1 73.84-73.84A73.91 73.91 0 0 1 519 806.75z m0-115.67a41.83 41.83 0 1 0 41.83 41.83A41.87 41.87 0 0 0 519 691.08z"
          fill="#05BAC5"
        ></path>
        <path
          d="M736.5 732.91m-57.83 0a57.83 57.83 0 1 0 115.66 0 57.83 57.83 0 1 0-115.66 0Z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M736.5 806.75a73.84 73.84 0 1 1 73.84-73.84 73.91 73.91 0 0 1-73.84 73.84z m0-115.67a41.83 41.83 0 1 0 41.83 41.83 41.87 41.87 0 0 0-41.83-41.83zM596.59 396.71L475.87 510.09c-6.37 6-16.82-0.42-13.7-8.31l26.44-66.45c2-5.12-2-10.59-7.82-10.59h-54.06c-7.34 0-11.08-8.24-6-13.22l115-113.38c6.23-6.16 17 0.07 13.91 8l-25.47 66.65c-1.94 5.12 2.08 10.45 7.82 10.45h58.71c7.41 0 11.14 8.45 5.88 13.43z"
          fill="#05BAC5"
        ></path>
      </symbol>
      <symbol id="icon-hot-w-meter" viewBox="0 0 1024 1024">
        <path
          d="M883.36 380.46v467.3a56.83 56.83 0 0 1-56.83 56.83H197.47a56.83 56.83 0 0 1-56.83-56.83v-676.4a52 52 0 0 1 51.95-51.95h633.94a56.83 56.83 0 0 1 56.83 56.83v204.22"
          fill="#CDF1F3"
        ></path>
        <path
          d="M826.54 920.5H197.46a72.83 72.83 0 0 1-72.74-72.74V171.37a67.94 67.94 0 0 1 67.87-67.87h634a72.83 72.83 0 0 1 72.74 72.74v671.52a72.83 72.83 0 0 1-72.79 72.74z m-634-785.17a36.08 36.08 0 0 0-36 36v676.43a41 41 0 0 0 40.91 40.91h629.09a41 41 0 0 0 40.91-40.91V176.24a41 41 0 0 0-40.91-40.91z"
          fill="#05BAC5"
        ></path>
        <path
          d="M724.21 416.58c0 117.21-95 212.21-212.21 212.21s-212.21-95-212.21-212.21 95-212.21 212.21-212.21 212.21 95 212.21 212.21z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M512 644.69c-125.79 0-228.12-102.33-228.12-228.12S386.21 188.45 512 188.45s228.12 102.33 228.12 228.12S637.79 644.69 512 644.69z m0-424.42c-108.24 0-196.29 88.05-196.29 196.29s88.05 196.3 196.29 196.3 196.29-88.05 196.29-196.29S620.24 220.28 512 220.28z"
          fill="#05BAC5"
        ></path>
        <path
          d="M320 697.7l-39.58 39.58a59.37 59.37 0 1 0 79.15 0z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M320 856.71a75.2 75.2 0 0 1-50.19-131.28l38.94-39a15.9 15.9 0 0 1 11.25-4.64 15.9 15.9 0 0 1 11.25 4.66L370.81 726A75.19 75.19 0 0 1 320 856.71z m0-136.51l-28.33 28.33c-9.84 8.85-15.13 20.62-15.13 32.89a43.45 43.45 0 1 0 72.41-32.29z"
          fill="#05BAC5"
        ></path>
        <path
          d="M533 697.7l-39.58 39.58a59.37 59.37 0 1 0 79.15 0z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M533 856.71a75.2 75.2 0 0 1-50.2-131.28l38.92-39a16.38 16.38 0 0 1 22.51 0L583.81 726A75.19 75.19 0 0 1 533 856.71z m0-136.51l-28.31 28.33c-9.84 8.85-15.13 20.62-15.13 32.89a43.45 43.45 0 1 0 72.41-32.29z"
          fill="#05BAC5"
        ></path>
        <path
          d="M746 697.7l-39.6 39.58a59.37 59.37 0 1 0 79.15 0z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M746 856.71a75.2 75.2 0 0 1-50.2-131.28l38.92-39a16.38 16.38 0 0 1 22.51 0L796.8 726A75.19 75.19 0 0 1 746 856.71z m0-136.51l-28.31 28.33c-9.84 8.85-15.13 20.62-15.13 32.89a43.45 43.45 0 1 0 72.41-32.29zM431.14 320.62v-29.55h27.23v29.55h28.53v26.46h-28.53v31.13l26.46-7.79v25.95c-8.83 2.59-17.64 4.93-26.46 7.25v35.29q0 26.45-24.89 26.44h-24.91l-6.22-25.92a160.71 160.71 0 0 0 21.53 1.8c4.66 0 7.25-3.11 7.25-9.08v-22c-11.42 2.34-22.57 4.68-34 6.76l-6.47-25.16q20.61-2.74 40.45-7v-37.67h-33.69v-26.46z m14.53 161.08c-9.08 20-19.71 37.07-31.64 51.35l-22.3-16.35a188.7 188.7 0 0 0 31.38-45.9zM502 525.53L474.72 532a326.43 326.43 0 0 0-11.94-48.51l25.41-5.18A488.32 488.32 0 0 1 502 525.53z m88.45-71.85c-11.17-12.45-16.87-38.9-16.87-78.85v-26.44h-26.51a229.31 229.31 0 0 1-6.22 48.49 332 332 0 0 1 30.61 27l-15.32 23.32a304.35 304.35 0 0 0-24.89-23.85 122 122 0 0 1-35.54 44.35l-20-17.91c15-11.15 26.19-25.68 33.72-43.56a210.74 210.74 0 0 0-21.8-14.28L502 370.69c5.18 3.11 10.36 6.22 15.29 9.35a235.43 235.43 0 0 0 3.38-31.64h-26.51v-26.47h26.46V290.8h26.44v31.13H600v52.91c0 27.23 1.55 45.9 5.18 56.28 1.55 4.66 2.86 7 3.9 7 1.28 0 2.59-3.9 3.63-11.15a212.72 212.72 0 0 0 1.29-23.08L634.48 414q-1.93 34.22-8.56 44.35c-3.11 4.41-6.74 6.76-11.42 6.76a31.62 31.62 0 0 1-24.1-11.43zM561.34 525l-27 6.49q-7-29.19-17.88-51.35l25.41-5.45A407.11 407.11 0 0 1 561.34 525z m65.36-8.56l-22.57 15.81q-12.84-23.34-35-52.12l22-13.76c15.6 19.21 27.27 35.81 35.58 50.09z"
          fill="#05BAC5"
        ></path>
      </symbol>
      <symbol id="icon-cold-w-meter" viewBox="0 0 1024 1024">
        <path
          d="M883.36 380.46v467.3a56.83 56.83 0 0 1-56.83 56.83H197.47a56.83 56.83 0 0 1-56.83-56.83v-676.4a52 52 0 0 1 51.95-51.95h633.94a56.83 56.83 0 0 1 56.83 56.83v204.22"
          fill="#CDF1F3"
        ></path>
        <path
          d="M826.54 920.5H197.46a72.83 72.83 0 0 1-72.74-72.74V171.37a67.94 67.94 0 0 1 67.87-67.87h634a72.83 72.83 0 0 1 72.74 72.74v671.52a72.83 72.83 0 0 1-72.79 72.74z m-634-785.17a36.08 36.08 0 0 0-36 36v676.43a41 41 0 0 0 40.91 40.91h629.09a41 41 0 0 0 40.91-40.91V176.24a41 41 0 0 0-40.91-40.91z"
          fill="#05BAC5"
        ></path>
        <path
          d="M724.21 416.58c0 117.21-95 212.21-212.21 212.21s-212.21-95-212.21-212.21 95-212.21 212.21-212.21 212.21 95 212.21 212.21z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M512 644.69c-125.79 0-228.12-102.33-228.12-228.12S386.21 188.45 512 188.45s228.12 102.33 228.12 228.12S637.79 644.69 512 644.69z m0-424.42c-108.24 0-196.29 88.05-196.29 196.29s88.05 196.3 196.29 196.3 196.29-88.05 196.29-196.29S620.24 220.28 512 220.28z"
          fill="#05BAC5"
        ></path>
        <path
          d="M320 697.7l-39.58 39.58a59.37 59.37 0 1 0 79.15 0z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M320 856.71a75.2 75.2 0 0 1-50.19-131.28l38.94-39a15.9 15.9 0 0 1 11.25-4.64 15.9 15.9 0 0 1 11.25 4.66L370.81 726A75.19 75.19 0 0 1 320 856.71z m0-136.51l-28.33 28.33c-9.84 8.85-15.13 20.62-15.13 32.89a43.45 43.45 0 1 0 72.41-32.29z"
          fill="#05BAC5"
        ></path>
        <path
          d="M533 697.7l-39.58 39.58a59.37 59.37 0 1 0 79.15 0z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M533 856.71a75.2 75.2 0 0 1-50.2-131.28l38.92-39a16.38 16.38 0 0 1 22.51 0L583.81 726A75.19 75.19 0 0 1 533 856.71z m0-136.51l-28.31 28.33c-9.84 8.85-15.13 20.62-15.13 32.89a43.45 43.45 0 1 0 72.41-32.29z"
          fill="#05BAC5"
        ></path>
        <path
          d="M746 697.7l-39.6 39.58a59.37 59.37 0 1 0 79.15 0z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M746 856.71a75.2 75.2 0 0 1-50.2-131.28l38.92-39a16.38 16.38 0 0 1 22.51 0L796.8 726A75.19 75.19 0 0 1 746 856.71z m0-136.51l-28.31 28.33c-9.84 8.85-15.13 20.62-15.13 32.89a43.45 43.45 0 1 0 72.41-32.29zM456.55 424.11a886 886 0 0 1-41.49 99.08L389.9 512a782.67 782.67 0 0 0 42.79-97zM454 350.46l-21.26 14.78c-9.86-15.81-23.6-33.2-41-52.39l21.78-13.74Q440 328.67 454 350.46z m95.72-60.18c16.33 31.64 44.6 59.14 84.8 83L620 395.06c-36.56-21.26-63.81-47.71-81.44-79.35Q505.84 369 456 397.67l-14-21.8c36.83-21.78 65.09-50.32 85.32-85.59z m57.57 115.16v22.3a334.18 334.18 0 0 1-53.18 61.74 368.3 368.3 0 0 1 31.64 24.12l-19.22 19.7q-29.56-28.38-84-60.95L500.65 455c11.42 6.74 22.3 13.22 32.43 20 13.74-11.92 28-27 42.52-44.6H465.38v-24.96z m-43.83-21l-15.87 18.66a208 208 0 0 0-35-31.38l17.64-16.33a194 194 0 0 1 33.19 29.04z"
          fill="#05BAC5"
        ></path>
      </symbol>
      <symbol id="icon-gateway" viewBox="0 0 1024 1024">
        <path
          d="M191.4 119.65h636.3a56.92 56.92 0 0 1 56.92 56.92v671a56.92 56.92 0 0 1-56.92 56.92H196.29a56.92 56.92 0 0 1-56.92-56.92V171.68a52 52 0 0 1 52.03-52.03z"
          fill="#CDF1F3"
        ></path>
        <path
          d="M827.71 920.5H196.29a73 73 0 0 1-72.92-72.92V171.67a68.1 68.1 0 0 1 68-68h636.3a73 73 0 0 1 72.92 72.92v671a73 73 0 0 1-72.88 72.91zM191.4 135.65a36.06 36.06 0 0 0-36 36v675.93a41 41 0 0 0 40.91 40.91h631.4a41 41 0 0 0 40.91-40.91v-671a41 41 0 0 0-40.91-40.91z"
          fill="#05BAC5"
        ></path>
        <path
          d="M181.77 119.5h656.6a44.95 44.95 0 0 1 44.95 44.95v401.32a44.95 44.95 0 0 1-44.95 44.95H185.63a44.95 44.95 0 0 1-44.95-44.95V160.59a41.09 41.09 0 0 1 41.09-41.09z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M838.37 626.72H185.63a61 61 0 0 1-60.95-61V160.58a57.15 57.15 0 0 1 57.09-57.08h656.6a61 61 0 0 1 60.95 60.95v401.31a61 61 0 0 1-60.95 60.96z m-656.6-491.21a25.11 25.11 0 0 0-25.08 25.08v405.17a29 29 0 0 0 28.94 29h652.74a29 29 0 0 0 28.94-29V164.45a29 29 0 0 0-28.94-28.94z"
          fill="#05BAC5"
        ></path>
        <path
          d="M294.59 761.85m-57.82 0a57.82 57.82 0 1 0 115.64 0 57.82 57.82 0 1 0-115.64 0Z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M294.59 835.67a73.82 73.82 0 1 1 73.83-73.82 73.9 73.9 0 0 1-73.83 73.82z m0-115.64a41.82 41.82 0 1 0 41.82 41.82A41.87 41.87 0 0 0 294.59 720z"
          fill="#05BAC5"
        ></path>
        <path
          d="M512 761.85m-57.82 0a57.82 57.82 0 1 0 115.64 0 57.82 57.82 0 1 0-115.64 0Z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M512 835.67a73.82 73.82 0 1 1 73.83-73.82A73.91 73.91 0 0 1 512 835.67zM512 720a41.82 41.82 0 1 0 41.82 41.82A41.87 41.87 0 0 0 512 720z"
          fill="#05BAC5"
        ></path>
        <path
          d="M729.41 761.85m-57.82 0a57.82 57.82 0 1 0 115.64 0 57.82 57.82 0 1 0-115.64 0Z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M729.41 835.67a73.82 73.82 0 1 1 73.83-73.82 73.91 73.91 0 0 1-73.83 73.82z m0-115.64a41.82 41.82 0 1 0 41.82 41.82A41.87 41.87 0 0 0 729.41 720zM510.55 468.12a16 16 0 0 1-16-16V283.29a16 16 0 1 1 32 0v168.82a16 16 0 0 1-16 16.01zM396.34 465.93a15.94 15.94 0 0 1-10.34-3.78 122.18 122.18 0 0 1-43-93.64c0-37.59 16.5-72.4 45.26-95.51a16 16 0 0 1 20 25c-21.16 17-33.3 42.71-33.3 70.55a90.21 90.21 0 0 0 31.65 69.2 16 16 0 0 1-10.35 28.22zM321 520.48a16 16 0 0 1-11.13-4.48c-39.11-37.9-61.54-91.42-61.54-146.83 0-57.16 23.64-111.82 64.86-150a16 16 0 1 1 21.74 23.48c-34.69 32.11-54.59 78.21-54.59 126.48 0 46.8 18.88 91.94 51.81 123.85a16 16 0 0 1-11.15 27.5zM624.2 465.93a16 16 0 0 1-10-28.47c21.16-17 33.3-42.72 33.3-70.56a90.2 90.2 0 0 0-31.64-69.2 16 16 0 0 1 20.66-24.44 122.15 122.15 0 0 1 43 93.64c0 37.58-16.5 72.4-45.26 95.5a15.93 15.93 0 0 1-10.06 3.53zM700 520.48a16 16 0 0 1-10.88-27.75c34.69-32.11 54.59-78.21 54.59-126.48 0-46.8-18.88-91.94-51.81-123.85a16 16 0 0 1 22.28-23c39.11 37.9 61.54 91.42 61.54 146.83 0 57.17-23.64 111.82-64.85 150a15.93 15.93 0 0 1-10.87 4.25z"
          fill="#05BAC5"
        ></path>
      </symbol>
      <symbol id="icon-ammeter-offline" viewBox="0 0 1024 1024">
        <path
          d="M191.35 92.85h636.4a56.93 56.93 0 0 1 56.93 56.93v671.11a56.93 56.93 0 0 1-56.93 56.93h-631.5a56.93 56.93 0 0 1-56.93-56.93v-676a52 52 0 0 1 52.03-52.04z"
          fill="#CDF1F3"
        ></path>
        <path
          d="M827.76 893.83H196.24a73 73 0 0 1-72.92-72.94v-676a68.11 68.11 0 0 1 68-68h636.44a73 73 0 0 1 72.92 72.94v671.06a73 73 0 0 1-72.92 72.94z m-636.41-785a36.07 36.07 0 0 0-36 36v676a41 41 0 0 0 40.91 40.93h631.5a41 41 0 0 0 40.91-40.93V149.77a41 41 0 0 0-40.91-40.93z"
          fill="#05BAC5"
        ></path>
        <path
          d="M243.77 206.8l543.32 0 0 344.43-543.32 0 0-344.43Z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M725 567.23H306a78.23 78.23 0 0 1-78.15-78.15V268.94A78.23 78.23 0 0 1 306 190.79h419a78.23 78.23 0 0 1 78.15 78.15v220.14A78.23 78.23 0 0 1 725 567.23zM306 222.79a46.19 46.19 0 0 0-46.14 46.14v220.15A46.19 46.19 0 0 0 306 535.22h419a46.19 46.19 0 0 0 46.14-46.14V268.94A46.19 46.19 0 0 0 725 222.8z"
          fill="#05BAC5"
        ></path>
        <path
          d="M301.6 706.24m-57.83 0a57.83 57.83 0 1 0 115.66 0 57.83 57.83 0 1 0-115.66 0Z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M301.59 780.08a73.84 73.84 0 1 1 73.84-73.84 73.91 73.91 0 0 1-73.84 73.84z m0-115.67a41.83 41.83 0 1 0 41.83 41.83 41.86 41.86 0 0 0-41.83-41.83z"
          fill="#05BAC5"
        ></path>
        <path
          d="M519.05 706.24m-57.83 0a57.83 57.83 0 1 0 115.66 0 57.83 57.83 0 1 0-115.66 0Z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M519 780.08a73.84 73.84 0 1 1 73.84-73.84A73.91 73.91 0 0 1 519 780.08z m0-115.67a41.83 41.83 0 1 0 41.83 41.83A41.87 41.87 0 0 0 519 664.41z"
          fill="#05BAC5"
        ></path>
        <path
          d="M736.5 706.24m-57.83 0a57.83 57.83 0 1 0 115.66 0 57.83 57.83 0 1 0-115.66 0Z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M736.5 780.08a73.84 73.84 0 1 1 73.84-73.84 73.91 73.91 0 0 1-73.84 73.84z m0-115.67a41.83 41.83 0 1 0 41.83 41.83 41.87 41.87 0 0 0-41.83-41.83zM596.59 370L475.87 483.42c-6.37 6-16.82-0.42-13.7-8.31l26.44-66.45c2-5.12-2-10.59-7.82-10.59h-54.06c-7.34 0-11.08-8.24-6-13.22l115-113.38c6.23-6.16 17 0.07 13.91 8l-25.47 66.65c-1.94 5.12 2.08 10.45 7.82 10.45h58.71c7.41 0 11.14 8.45 5.88 13.43z"
          fill="#05BAC5"
        ></path>
        <path
          d="M191.35 92.85h636.4a56.93 56.93 0 0 1 56.93 56.93v671.11a56.93 56.93 0 0 1-56.93 56.93h-631.5a56.93 56.93 0 0 1-56.93-56.93v-676a52 52 0 0 1 52.03-52.04z"
          fill="#F8F8F9"
        ></path>
        <path
          d="M827.76 893.83H196.24a73 73 0 0 1-72.92-72.94v-676a68.11 68.11 0 0 1 68-68h636.44a73 73 0 0 1 72.92 72.94v671.06a73 73 0 0 1-72.92 72.94z m-636.41-785a36.07 36.07 0 0 0-36 36v676a41 41 0 0 0 40.91 40.93h631.5a41 41 0 0 0 40.91-40.93V149.77a41 41 0 0 0-40.91-40.93z"
          fill="#BBBEC4"
        ></path>
        <path
          d="M243.77 206.8l543.32 0 0 344.43-543.32 0 0-344.43Z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M725 567.23H306a78.23 78.23 0 0 1-78.15-78.15V268.94A78.23 78.23 0 0 1 306 190.79h419a78.23 78.23 0 0 1 78.15 78.15v220.14A78.23 78.23 0 0 1 725 567.23zM306 222.79a46.19 46.19 0 0 0-46.14 46.14v220.15A46.19 46.19 0 0 0 306 535.22h419a46.19 46.19 0 0 0 46.14-46.14V268.94A46.19 46.19 0 0 0 725 222.8z"
          fill="#BBBEC4"
        ></path>
        <path
          d="M301.6 706.24m-57.83 0a57.83 57.83 0 1 0 115.66 0 57.83 57.83 0 1 0-115.66 0Z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M301.59 780.08a73.84 73.84 0 1 1 73.84-73.84 73.91 73.91 0 0 1-73.84 73.84z m0-115.67a41.83 41.83 0 1 0 41.83 41.83 41.86 41.86 0 0 0-41.83-41.83z"
          fill="#BBBEC4"
        ></path>
        <path
          d="M519.05 706.24m-57.83 0a57.83 57.83 0 1 0 115.66 0 57.83 57.83 0 1 0-115.66 0Z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M519 780.08a73.84 73.84 0 1 1 73.84-73.84A73.91 73.91 0 0 1 519 780.08z m0-115.67a41.83 41.83 0 1 0 41.83 41.83A41.87 41.87 0 0 0 519 664.41z"
          fill="#BBBEC4"
        ></path>
        <path
          d="M736.5 706.24m-57.83 0a57.83 57.83 0 1 0 115.66 0 57.83 57.83 0 1 0-115.66 0Z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M736.5 780.08a73.84 73.84 0 1 1 73.84-73.84 73.91 73.91 0 0 1-73.84 73.84z m0-115.67a41.83 41.83 0 1 0 41.83 41.83 41.87 41.87 0 0 0-41.83-41.83zM596.59 370L475.87 483.42c-6.37 6-16.82-0.42-13.7-8.31l26.44-66.45c2-5.12-2-10.59-7.82-10.59h-54.06c-7.34 0-11.08-8.24-6-13.22l115-113.38c6.23-6.16 17 0.07 13.91 8l-25.47 66.65c-1.94 5.12 2.08 10.45 7.82 10.45h58.71c7.41 0 11.14 8.45 5.88 13.43z"
          fill="#BBBEC4"
        ></path>
      </symbol>
      <symbol id="icon-lock-offline" viewBox="0 0 1024 1024">
        <path
          d="M159.95 119.44l523.27 0 0 785.12-523.27 0 0-785.12Z"
          fill="#F8F8F9"
        ></path>
        <path
          d="M623 920.5H220.19A76.27 76.27 0 0 1 144 844.31V179.69a76.27 76.27 0 0 1 76.18-76.19H623a76.28 76.28 0 0 1 76.19 76.19v664.62A76.28 76.28 0 0 1 623 920.5zM220.19 135.38a44.36 44.36 0 0 0-44.3 44.31v664.62a44.36 44.36 0 0 0 44.3 44.31H623a44.37 44.37 0 0 0 44.31-44.31V179.69A44.37 44.37 0 0 0 623 135.38z"
          fill="#BBBEC4"
        ></path>
        <path
          d="M434.24 519.36m-141.03 0a141.03 141.03 0 1 0 282.06 0 141.03 141.03 0 1 0-282.06 0Z"
          fill="#F8F8F9"
        ></path>
        <path
          d="M434.23 676.33c-86.56 0-157-70.41-157-157s70.41-157 157-157 157 70.41 157 157-70.44 157-157 157z m0-282.05a125.09 125.09 0 1 0 125.09 125.09 125.22 125.22 0 0 0-125.09-125.09z"
          fill="#BBBEC4"
        ></path>
        <path
          d="M379.13 450.59l484.91 0 0 145.26-484.91 0 0-145.26Z"
          fill="#F8F8F9"
        ></path>
        <path
          d="M791.42 611.79H451.76a88.57 88.57 0 0 1 0-177.14h339.66a88.57 88.57 0 1 1 0 177.14zM451.76 466.53a56.69 56.69 0 1 0 0 113.38h339.66a56.69 56.69 0 0 0 0-113.38z"
          fill="#BBBEC4"
        ></path>
      </symbol>
      <symbol id="icon-cold-w-meter-offline" viewBox="0 0 1024 1024">
        <path
          d="M883.36 380.46v467.3a56.83 56.83 0 0 1-56.83 56.83H197.47a56.83 56.83 0 0 1-56.83-56.83v-676.4a52 52 0 0 1 51.95-51.95h633.94a56.83 56.83 0 0 1 56.83 56.83v204.22"
          fill="#F8F8F9"
        ></path>
        <path
          d="M826.54 920.5H197.46a72.83 72.83 0 0 1-72.74-72.74V171.37a67.94 67.94 0 0 1 67.87-67.87h634a72.83 72.83 0 0 1 72.74 72.74v671.52a72.83 72.83 0 0 1-72.79 72.74z m-634-785.17a36.08 36.08 0 0 0-36 36v676.43a41 41 0 0 0 40.91 40.91h629.09a41 41 0 0 0 40.91-40.91V176.24a41 41 0 0 0-40.91-40.91z"
          fill="#BBBEC4"
        ></path>
        <path
          d="M724.21 416.58c0 117.21-95 212.21-212.21 212.21s-212.21-95-212.21-212.21 95-212.21 212.21-212.21 212.21 95 212.21 212.21z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M512 644.69c-125.79 0-228.12-102.33-228.12-228.12S386.21 188.45 512 188.45s228.12 102.33 228.12 228.12S637.79 644.69 512 644.69z m0-424.42c-108.24 0-196.29 88.05-196.29 196.29s88.05 196.3 196.29 196.3 196.29-88.05 196.29-196.29S620.24 220.28 512 220.28z"
          fill="#BBBEC4"
        ></path>
        <path
          d="M320 697.7l-39.58 39.58a59.37 59.37 0 1 0 79.15 0z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M320 856.71a75.2 75.2 0 0 1-50.19-131.28l38.94-39a15.9 15.9 0 0 1 11.25-4.64 15.9 15.9 0 0 1 11.25 4.66L370.81 726A75.19 75.19 0 0 1 320 856.71z m0-136.51l-28.33 28.33c-9.84 8.85-15.13 20.62-15.13 32.89a43.45 43.45 0 1 0 72.41-32.29z"
          fill="#BBBEC4"
        ></path>
        <path
          d="M533 697.7l-39.58 39.58a59.37 59.37 0 1 0 79.15 0z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M533 856.71a75.2 75.2 0 0 1-50.2-131.28l38.92-39a16.38 16.38 0 0 1 22.51 0L583.81 726A75.19 75.19 0 0 1 533 856.71z m0-136.51l-28.31 28.33c-9.84 8.85-15.13 20.62-15.13 32.89a43.45 43.45 0 1 0 72.41-32.29z"
          fill="#BBBEC4"
        ></path>
        <path
          d="M746 697.7l-39.6 39.58a59.37 59.37 0 1 0 79.15 0z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M746 856.71a75.2 75.2 0 0 1-50.2-131.28l38.92-39a16.38 16.38 0 0 1 22.51 0L796.8 726A75.19 75.19 0 0 1 746 856.71z m0-136.51l-28.31 28.33c-9.84 8.85-15.13 20.62-15.13 32.89a43.45 43.45 0 1 0 72.41-32.29zM456.56 424.11a886 886 0 0 1-41.49 99.08L389.91 512a782.67 782.67 0 0 0 42.79-97zM454 350.46l-21.3 14.78c-9.86-15.81-23.6-33.2-41-52.39l21.78-13.74Q440 328.67 454 350.46z m95.72-60.18c16.33 31.64 44.6 59.14 84.8 83L620 395.06c-36.56-21.26-63.81-47.71-81.44-79.35Q505.85 369 456 397.67l-14-21.8c36.83-21.78 65.09-50.32 85.32-85.59z m57.57 115.16v22.3a334.18 334.18 0 0 1-53.18 61.74 368.3 368.3 0 0 1 31.64 24.12l-19.22 19.7q-29.56-28.38-84-60.95L500.65 455c11.42 6.74 22.3 13.22 32.43 20 13.74-11.92 28-27 42.52-44.6H465.38v-24.96z m-43.83-21l-15.87 18.66a208 208 0 0 0-35-31.38l17.64-16.33a194 194 0 0 1 33.2 29.04z"
          fill="#BBBEC4"
        ></path>
      </symbol>
      <symbol id="icon-hot-w-meter-offline" viewBox="0 0 1024 1024">
        <path
          d="M883.36 380.46v467.3a56.83 56.83 0 0 1-56.83 56.83H197.47a56.83 56.83 0 0 1-56.83-56.83v-676.4a52 52 0 0 1 51.95-51.95h633.94a56.83 56.83 0 0 1 56.83 56.83v204.22"
          fill="#F8F8F9"
        ></path>
        <path
          d="M826.54 920.5H197.46a72.83 72.83 0 0 1-72.74-72.74V171.37a67.94 67.94 0 0 1 67.87-67.87h634a72.83 72.83 0 0 1 72.74 72.74v671.52a72.83 72.83 0 0 1-72.79 72.74z m-634-785.17a36.08 36.08 0 0 0-36 36v676.43a41 41 0 0 0 40.91 40.91h629.09a41 41 0 0 0 40.91-40.91V176.24a41 41 0 0 0-40.91-40.91z"
          fill="#BBBEC4"
        ></path>
        <path
          d="M724.21 416.58c0 117.21-95 212.21-212.21 212.21s-212.21-95-212.21-212.21 95-212.21 212.21-212.21 212.21 95 212.21 212.21z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M512 644.69c-125.79 0-228.12-102.33-228.12-228.12S386.21 188.45 512 188.45s228.12 102.33 228.12 228.12S637.79 644.69 512 644.69z m0-424.42c-108.24 0-196.29 88.05-196.29 196.29s88.05 196.3 196.29 196.3 196.29-88.05 196.29-196.29S620.24 220.28 512 220.28z"
          fill="#BBBEC4"
        ></path>
        <path
          d="M320 697.7l-39.58 39.58a59.37 59.37 0 1 0 79.15 0z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M320 856.71a75.2 75.2 0 0 1-50.19-131.28l38.94-39a15.9 15.9 0 0 1 11.25-4.64 15.9 15.9 0 0 1 11.25 4.66L370.81 726A75.19 75.19 0 0 1 320 856.71z m0-136.51l-28.33 28.33c-9.84 8.85-15.13 20.62-15.13 32.89a43.45 43.45 0 1 0 72.41-32.29z"
          fill="#BBBEC4"
        ></path>
        <path
          d="M533 697.7l-39.58 39.58a59.37 59.37 0 1 0 79.15 0z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M533 856.71a75.2 75.2 0 0 1-50.2-131.28l38.92-39a16.38 16.38 0 0 1 22.51 0L583.81 726A75.19 75.19 0 0 1 533 856.71z m0-136.51l-28.31 28.33c-9.84 8.85-15.13 20.62-15.13 32.89a43.45 43.45 0 1 0 72.41-32.29z"
          fill="#BBBEC4"
        ></path>
        <path
          d="M746 697.7l-39.6 39.58a59.37 59.37 0 1 0 79.15 0z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M746 856.71a75.2 75.2 0 0 1-50.2-131.28l38.92-39a16.38 16.38 0 0 1 22.51 0L796.8 726A75.19 75.19 0 0 1 746 856.71z m0-136.51l-28.31 28.33c-9.84 8.85-15.13 20.62-15.13 32.89a43.45 43.45 0 1 0 72.41-32.29zM431.14 320.62v-29.55h27.23v29.55h28.53v26.46h-28.53v31.13l26.46-7.79v25.95c-8.83 2.59-17.64 4.93-26.46 7.25v35.29q0 26.45-24.89 26.44h-24.91l-6.22-25.92a160.71 160.71 0 0 0 21.53 1.8c4.66 0 7.25-3.11 7.25-9.08v-22c-11.42 2.34-22.57 4.68-34 6.76l-6.47-25.16q20.61-2.74 40.45-7v-37.67h-33.69v-26.46z m14.52 161.08c-9.08 20-19.71 37.07-31.64 51.35l-22.3-16.35a188.7 188.7 0 0 0 31.38-45.9z m56.28 43.83L474.72 532a326.43 326.43 0 0 0-11.94-48.51l25.41-5.18a488.32 488.32 0 0 1 13.76 47.22z m88.45-71.85c-11.17-12.45-16.87-38.9-16.87-78.85v-26.44h-26.46a229.31 229.31 0 0 1-6.22 48.49 332 332 0 0 1 30.61 27l-15.31 23.32a304.35 304.35 0 0 0-24.89-23.85 122 122 0 0 1-35.54 44.35l-20-17.91c15-11.15 26.19-25.68 33.72-43.56a210.74 210.74 0 0 0-21.8-14.28l14.28-21.26c5.18 3.11 10.36 6.22 15.29 9.35a235.43 235.43 0 0 0 3.38-31.64h-26.42v-26.47h26.46V290.8h26.44v31.13H600v52.91c0 27.23 1.55 45.9 5.18 56.28 1.55 4.66 2.86 7 3.9 7 1.28 0 2.59-3.9 3.63-11.15a212.72 212.72 0 0 0 1.29-23.08L634.47 414q-1.93 34.22-8.56 44.35c-3.11 4.41-6.74 6.76-11.42 6.76a31.62 31.62 0 0 1-24.09-11.43zM561.34 525l-27 6.49q-7-29.19-17.88-51.35l25.41-5.45A407.11 407.11 0 0 1 561.34 525z m65.36-8.56l-22.57 15.81q-12.84-23.34-35-52.12l22-13.76c15.6 19.21 27.26 35.81 35.57 50.09z"
          fill="#BBBEC4"
        ></path>
      </symbol>
      <symbol id="icon-gateway-offline" viewBox="0 0 1024 1024">
        <path
          d="M191.4 119.65h636.3a56.92 56.92 0 0 1 56.92 56.92v671a56.92 56.92 0 0 1-56.92 56.92H196.29a56.92 56.92 0 0 1-56.92-56.92V171.68a52 52 0 0 1 52.03-52.03z"
          fill="#F8F8F9"
        ></path>
        <path
          d="M827.71 920.5H196.29a73 73 0 0 1-72.92-72.92v-675.9a68.11 68.11 0 0 1 68-68h636.34a73 73 0 0 1 72.92 72.92v671a73 73 0 0 1-72.92 72.9zM191.4 135.65a36.06 36.06 0 0 0-36 36v675.9a41 41 0 0 0 40.91 40.91h631.4a41 41 0 0 0 40.91-40.91v-671a41 41 0 0 0-40.91-40.91z"
          fill="#BBBEC4"
        ></path>
        <path
          d="M181.77 119.5h656.6a44.95 44.95 0 0 1 44.95 44.95v401.32a44.95 44.95 0 0 1-44.95 44.95H185.63a44.95 44.95 0 0 1-44.95-44.95V160.59a41.09 41.09 0 0 1 41.09-41.09z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M838.37 626.72H185.63a61 61 0 0 1-61-61V160.58a57.15 57.15 0 0 1 57.09-57.08h656.6a61 61 0 0 1 61 60.95v401.31a61 61 0 0 1-60.95 60.96z m-656.6-491.21a25.11 25.11 0 0 0-25.08 25.08v405.17a29 29 0 0 0 28.95 29h652.73a29 29 0 0 0 28.95-29V164.45a29 29 0 0 0-28.95-28.94z"
          fill="#BBBEC4"
        ></path>
        <path
          d="M294.59 761.85m-57.82 0a57.82 57.82 0 1 0 115.64 0 57.82 57.82 0 1 0-115.64 0Z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M294.59 835.57a73.72 73.72 0 1 1 73.72-73.71 73.8 73.8 0 0 1-73.72 73.71z m0-115.64a41.92 41.92 0 1 0 41.92 41.93 42 42 0 0 0-41.92-41.93z"
          fill="#BBBEC4"
        ></path>
        <path
          d="M512 761.85m-57.82 0a57.82 57.82 0 1 0 115.64 0 57.82 57.82 0 1 0-115.64 0Z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M512 835.57a73.72 73.72 0 1 1 73.72-73.71A73.8 73.8 0 0 1 512 835.57z m0-115.64a41.92 41.92 0 1 0 41.92 41.93A42 42 0 0 0 512 719.93z"
          fill="#BBBEC4"
        ></path>
        <path
          d="M729.41 761.85m-57.82 0a57.82 57.82 0 1 0 115.64 0 57.82 57.82 0 1 0-115.64 0Z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M729.42 835.57a73.72 73.72 0 1 1 73.72-73.71 73.8 73.8 0 0 1-73.72 73.71z m0-115.64a41.92 41.92 0 1 0 41.92 41.93 42 42 0 0 0-41.92-41.93zM510.55 468.12a16 16 0 0 1-16-16V283.29a16 16 0 1 1 32 0v168.82a16 16 0 0 1-16 16.01zM396.33 465.93a15.94 15.94 0 0 1-10.33-3.78 122.19 122.19 0 0 1-43-93.64c0-37.59 16.5-72.4 45.26-95.51a16 16 0 0 1 20 25c-21.16 17-33.3 42.71-33.3 70.55a90.22 90.22 0 0 0 31.65 69.2 16 16 0 0 1-10.35 28.22zM321 520.48a16 16 0 0 1-11.14-4.48c-39.11-37.9-61.54-91.41-61.54-146.83 0-57.17 23.64-111.82 64.85-150a16 16 0 1 1 21.74 23.48c-34.69 32.11-54.59 78.21-54.59 126.48 0 46.8 18.88 91.95 51.81 123.85a16 16 0 0 1-11.13 27.5zM624.2 465.93a16 16 0 0 1-10-28.47c21.16-17 33.3-42.73 33.3-70.56a90.22 90.22 0 0 0-31.65-69.2 16 16 0 1 1 20.66-24.44 122.17 122.17 0 0 1 43 93.64c0 37.58-16.5 72.39-45.26 95.5a15.93 15.93 0 0 1-10.05 3.53zM700 520.48a16 16 0 0 1-10.88-27.75c34.69-32.11 54.59-78.21 54.59-126.48 0-46.8-18.88-91.95-51.81-123.85a16 16 0 0 1 22.28-23c39.11 37.9 61.54 91.41 61.54 146.83 0 57.17-23.64 111.82-64.85 150a15.93 15.93 0 0 1-10.87 4.25z"
          fill="#BBBEC4"
        ></path>
      </symbol>
    </svg>
  </div>
</template>
<script>
export default {};
</script>